import clsx from 'clsx';

import type { TimeRangeOption } from '../../types';
import { formatTimeRange, getTimeRangeKey } from '../../utils';

import styles from './timeRangeTabs.module.css';

export interface TimeRangeTabsProps {
  ranges: readonly TimeRangeOption[];
  value?: TimeRangeOption | null;
  disabled?: boolean;
  getLabel?: (range: TimeRangeOption) => string;
  onChange: (range: TimeRangeOption) => void;
}

const TimeRangeTabs = ({
  ranges,
  value,
  disabled = false,
  getLabel = formatTimeRange,
  onChange
}: TimeRangeTabsProps) => (
  <div className={styles.tabs}>
    {ranges.map(range => {
      const key = getTimeRangeKey(range);
      const active = value ? getTimeRangeKey(value) === key : false;
      return (
        <button
          key={key}
          type="button"
          aria-pressed={active}
          className={clsx(styles.tab, active && styles.active)}
          disabled={disabled}
          onClick={() => onChange(range)}
        >
          {getLabel(range)}
        </button>
      );
    })}
  </div>
);

export default TimeRangeTabs;
